// extracted by mini-css-extract-plugin
export default {"emailKindCellRoot":"emailKindCellRoot--Glj39","label":"label--h_9vg","icon":"icon--cqut8"};